import { useEffect } from "react";
import CareerApply from "../components/CareerApply/CareerApply";
import CareerCard from "../components/CareerCard/CareerCard";
import Footerr from "../components/Footerr/Footerr";
import { Header } from "../components/shared";
import usePageMeta from "../../seo/usePageMeta";
import { useRegion } from "../../regions/RegionContext";

function CareerPage() {
  const { config } = useRegion();
  usePageMeta({
    title: "Careers | Terces Solutions",
    description: config.content.careersBlurb,
    path: "/Careers",
  });

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="career-page">
      <Header />
      <main className="career-content">
        <CareerApply />
        <CareerCard />
      </main>
      <Footerr />
    </div>
  );
}

export default CareerPage;
